import { render, staticRenderFns } from "./StandardEquipments.vue?vue&type=template&id=f13b97e0&scoped=true&"
import script from "./StandardEquipments.vue?vue&type=script&lang=js&"
export * from "./StandardEquipments.vue?vue&type=script&lang=js&"
import style0 from "./StandardEquipments.vue?vue&type=style&index=0&id=f13b97e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13b97e0",
  null
  
)

export default component.exports